import { useEffect, useState } from "react";
import { collection, onSnapshot, query, where, limit } from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import { resolveFacilities } from "../common/isgRuleEngine";
import { db } from "../firebaseConfig";

const SOURCES = {
  templates: "isg_sablonlar",
  readingPolicies: "isg_okuma_kurallari", durationHistory: "isg_sure_gecmisi", definitions: "isg_tanimlar", facilities: "isg_tesis_ayarlari", typeMappings: "isg_belge_eslestirmeleri", workplaceDocs: "isg_belgeler",
  appointments: "isg_gorevlendirmeler", actions: "isg_aksiyonlar", analyses: "isg_analizler",
  dailySummaries: "isg_gunluk_ozetler", persons: "personeller", vehicles: "plates",
  personDocs: "personelDocs", personTypes: "personelDocTypes", vehicleDocs: "aracDocs", vehicleTypes: "aracDocTypes",
  existingFacilities: "tesisler",
  incidentMappings: "isg_olay_eslestirmeleri",
};
export const emptyData = () => Object.fromEntries([...Object.keys(SOURCES), "incidents"].map((key) => [key, []]));
export function useIsgData(enabled, startDate, user, creator = false, manager = false) {
  const [data, setData] = useState(emptyData);
  const [loaded, setLoaded] = useState({});
  const [errors, setErrors] = useState({});
  useEffect(() => {
    if (!enabled) return undefined;
    setData(emptyData()); setLoaded({}); setErrors({});
    const unsubs = Object.entries(SOURCES).map(([key, name]) => {
      if (["durationHistory", "readingPolicies"].includes(key) && !manager) { setLoaded((prev) => ({ ...prev, [key]: true })); return () => {}; }
      return onSnapshot(key === "analyses" && !creator ? query(collection(db, name), where("createdByUid", "==", user?.uid || "")) : collection(db, name), (snapshot) => {
      setData((prev) => ({ ...prev, [key]: snapshot.docs.map((d) => ({ ...d.data(), id: d.id })) }));
      setLoaded((prev) => ({ ...prev, [key]: true }));
      setErrors((prev) => ({ ...prev, [key]: "" }));
    }, () => setErrors((prev) => ({ ...prev, [key]: `${name} okunamadı. Bağlantı ve erişim yetkisini kontrol edin.` }))); });
    return () => unsubs.forEach((u) => u());
  }, [enabled, user?.email, user?.uid, creator, manager]);
  useEffect(() => {
    if (!enabled) return undefined;
    setLoaded((prev) => ({ ...prev, incidents: false }));
    return onSnapshot(query(collection(db, "kazalar"), where("tarih", ">=", new Date(`${startDate}T00:00:00`)), limit(1000)), (snapshot) => {
      setData((prev) => ({ ...prev, incidents: snapshot.docs.map((d) => ({ ...d.data(), id: d.id })) }));
      setLoaded((prev) => ({ ...prev, incidents: true }));
      setErrors((prev) => ({ ...prev, incidents: snapshot.size === 1000 ? "Kaza listesi 1000 kayıtla sınırlı. Daha yakın başlangıç tarihi seçin." : "" }));
    }, () => setErrors((prev) => ({ ...prev, incidents: "Kaza kayıtları okunamadı." })));
  }, [enabled, startDate, user?.email, creator]);
  return { data: { ...data, facilities: resolveFacilities(data.facilities, data.existingFacilities) }, errors: Object.values(errors).filter(Boolean), ready: [...Object.keys(SOURCES), "incidents"].every((key) => loaded[key]) };
}
export async function callIsg(name, data = {}) {
  try {
    const response = await httpsCallable(getFunctions(undefined, "us-central1"), name, { timeout: 300000 })(data);
    return response.data;
  } catch (error) {
    if (["functions/not-found", "functions/unavailable", "functions/internal"].includes(error.code)) throw new Error("İSG sunucu hizmetine ulaşılamadı. Functions yayını ve sunucu ayarları kontrol edilmeli.");
    throw new Error(error.message || "İşlem tamamlanamadı.");
  }
}
